import combineReducers from 'redux/lib/combineReducers';

import geoFence from './geoFence';

export default combineReducers({
  geoFence,
});
